import axios from 'axios';
// import qs from 'qs';
import router from "@/router.js";
import Comjs from "@/assets/js/common.js";
import Cookies from "js-cookie";
import { httpAuthAxios } from "./request";

const HOST_URL_export = process.env.VUE_APP_EXPORT_API;

// 是否正在刷新token
let isRefreshing = false;

// 重试队列
let retryRequests = [];

async function refreshTokenMethod(response) {
  // 如果没有token或refreshToken，直接登出
  const refreshToken = Cookies.get("Dealer-User-RefreshToken");

  const toekn = Cookies.get("Dealer-User-Token")
  
  // 没有刷新token直接退出
  if (!refreshToken) {
    retryRequests = [];
    Comjs.removeDealer();
    router.push("/login");
  }

  const config = response.config;

  // token不一致 之前可能存在refresh的调用，直接再次请求 
  if(toekn !== config.headers.Authorization) {
    config.headers.Authorization = token;
    httpAuthAxios.request(config)
  }

  // token失效，前端续期token刷新
  if (isRefreshing) {
    // 将请求加入重试队列
    return new Promise((resolve) => {
      retryRequests.push((token) => {
        config.headers.Authorization = token;
        resolve(httpAuthAxios.request(config));
      });
    });
  } else {
    isRefreshing = true;
    
    try {
      // 调用刷新token接口
      const refreshResponse = await axios({
        baseURL: HOST_URL_export,
        method: 'POST',
        data: {},
        headers: {
          Authorization: refreshToken
        },
        timeout: 4000,
        url: `/v2/appUserService/refresh`,
      });
      if(refreshResponse.status == 200) {
        const { refreshToken: t, accessToken } = refreshResponse.data;
        // 更新token
        Cookies.set("Dealer-User-Token", accessToken);
        Cookies.set("Dealer-User-RefreshToken", t);
        // 重试队列中的请求
        retryRequests.forEach((cb) => cb(accessToken));
        retryRequests = [];
  
        // 重试当前请求
        config.headers.Authorization = accessToken;
        return httpAuthAxios.request(config);
      } else {
        retryRequests = [];
        Comjs.removeDealer();
        router.push("/login");
      }

    } catch (error) {
      retryRequests = [];
      Comjs.removeDealer();
      router.push("/login");
      return Promise.reject(error);
    } finally {
      isRefreshing = false;
    }
  }
}

export {
  refreshTokenMethod,
};